namespace cdh.capture {

    export var hasCamera = false;
    export var hasMic = false;
    export var canRecordAudio = false;

    export var checkComplete: Promise<void>;

    if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices)
        checkComplete = navigator.mediaDevices.enumerateDevices().then(dArr => {
            hasCamera = dArr.some(d => d.kind == "videoinput");
            hasMic = dArr.some(d => d.kind == "audioinput");

            if (MediaRecorder)
                canRecordAudio = hasMic;

        });


    export class VideoCapture {
        private _md: MediaStream

        width = 320
        height: number;

        streaming: boolean = false;
        readonly isBusy = utils.createBusyCounter();
        readonly canvElm: HTMLCanvasElement;
        imgElm: HTMLImageElement;
        onUpdatePhoto?: (canvas: HTMLCanvasElement) => Promise<void>;

        imgType?: string;
        onImageTaken?: (img: Blob) => Promise<void>;


        constructor(readonly vidElm: HTMLVideoElement) {
            if (!hasCamera) throw new Error("No Camera detected");

            vidElm.addEventListener("canplay", this.onCanplay.bind(this));
            this.canvElm = document.createElement("canvas");
        }

        async beginCapture() {
            if (this._md) throw new Error("Already Started");

            try {

                //this._md = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment", frameRate: { ideal: 10, max: 15 }, width: { ideal: 4096 }, height: { ideal: 2160 } }, audio: false });
                this._md = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment", frameRate: { ideal: 10, max: 15 }, width: { ideal: 2096 }, height: { ideal: 1160 } }, audio: false });

                this.vidElm.srcObject = this._md;
                this.vidElm.play();
            }
            catch (err) {
                console.log("videoCapture.beginCapture error: ", err);


                if (err.name)
                    switch (err.name) {
                        case "NotFoundError":
                        case "DevicesNotFoundError":
                            //required track is missing
                            break;

                        case "NotReadableError":
                        case "TrackStartError":
                            //webcam or mic are already in use
                            break;
                        case "OverconstrainedError":
                        case "ConstraintNotSatisfiedError":
                            // constraints can not be satisfied by avb. devices
                            break;
                        case "NotAllowedError":
                        case "PermissionDeniedError":
                            hasCamera = false;
                            this.endCapture();
                            // permission denied in browser
                            break;
                        case "TypeError":
                            //empty constraints object
                            break;
                        default:
                        //other errors
                    }

                throw err;
            }
        }

        private updatePhoto(send = true) {
            let self = this;

            if (self.imgElm) {
                var data = self.canvElm.toDataURL('image/png');
                self.imgElm.setAttribute("src", data);
            }
            if (send) {
                if (self.isBusy()) return;

                if (self.onUpdatePhoto)
                    self.isBusy.setBusy(self.onUpdatePhoto(self.canvElm));
                else if (self.onImageTaken) {

                    self.canvElm.toBlob(async b => {
                        let d = self.isBusy.beginUsing();
                        try {
                            var data = await self.onImageTaken(b);
                            console.log(data);
                        }
                        catch (ex) {
                            console.log(ex);
                        }
                        finally {
                            d.dispose();
                        }
                    }, self.imgType || 'image/png');

                }
            }
        }

        clearPhoto() {
            var ctx = this.canvElm.getContext('2d');
            ctx.fillStyle = "#AAA";
            ctx.fillRect(0, 0, this.canvElm.width, this.canvElm.height);

            this.updatePhoto(false);
        }

        takePicture() {
            var ctx = this.canvElm.getContext('2d');
            if (this.streaming) {
                this.canvElm.width = this.vidElm.videoWidth;
                this.canvElm.height = this.vidElm.videoHeight;
                ctx.drawImage(this.vidElm, 0, 0, this.vidElm.videoWidth, this.vidElm.videoHeight);

                this.updatePhoto();
            } else {
                this.clearPhoto();
            }
        }

        onCanplay(ev: Event): void {
            if (!this.streaming) {
                //this.width = this.vidElm.width;
                this.height = this.vidElm.videoHeight / (this.vidElm.videoWidth / this.width);

                //this.vidElm.width = this.width;
                //this.vidElm.height = this.height;
                this.canvElm.width = this.vidElm.videoWidth;
                this.canvElm.height = this.vidElm.videoHeight;

                this.clearPhoto();
                this.streaming = true;
            }
        }

        endCapture() {
            if (this._md) {
                if (this._md.stop)
                    this._md.stop();
                else
                    this._md.getTracks().map(t => t.stop());
            }
            this._md = null;
            this.vidElm.srcObject = null;
            this.streaming = false;
        }
    }

    export class AudioCapture {
        private _md: MediaStream;
        private _rec: MediaRecorder;
        private _res?: Promise<Blob>;
        private _cbComplete = $.Callbacks();

        readonly recording = ko.observable(false);

        async start() {
            if (this._rec) throw new Error("already Recording");

            if (!this._md)
                await this.beginCapture();

            var rec = this._rec = new MediaRecorder(this._md);
            var chunks: Blob[] = [];

            rec.addEventListener("dataavailable", e => chunks.push(e.data));
            rec.ondataavailable = e => chunks.push(e.data);

            var def = $.Deferred();
            this._res = def.promise();
            var self = this;

            rec.addEventListener("stop", e => {
                var res = new Blob(chunks, {
                    type: rec.mimeType || chunks[0].type
                });
                def.resolve(res);

                self._rec = null;
                self._res = null;

                self.recording(false);
                this._cbComplete.fire(res);
            });

            rec.start();
            self.recording(true);

        }
        async stop(): Promise<Blob> {

            if (!this._res) return null;

            var res = this._res;
            var rec = this._rec;

            rec.stop();

            this._rec = null;
            this._res = null;

            return res;

        }


        constructor() {
            if (!canRecordAudio) throw new Error("Can't Record Audio");
        }

        async beginCapture() {
            if (this._md) throw new Error("Already Started");

            try {

                this._md = await navigator.mediaDevices.getUserMedia({ video: false, audio: true });

            }
            catch (err) {
                console.log("audioCapture.beginCapture error: ", err);


                if (err.name)
                    switch (err.name) {
                        case "NotFoundError":
                        case "DevicesNotFoundError":
                            //required track is missing
                            break;

                        case "NotReadableError":
                        case "TrackStartError":
                            //webcam or mic are already in use
                            break;
                        case "OverconstrainedError":
                        case "ConstraintNotSatisfiedError":
                            // constraints can not be satisfied by avb. devices
                            break;
                        case "NotAllowedError":
                        case "PermissionDeniedError":
                            hasCamera = false;
                            this.endCapture();
                            // permission denied in browser
                            break;
                        case "TypeError":
                            //empty constraints object
                            break;
                        default:
                        //other errors
                    }

                throw err;
            }
        }

        addCompletedCallback(cb: { (data: Blob): void }): void {
            this._cbComplete.add(cb);
        }

        endCapture() {

            if (this._rec) {
                this._rec.stop();
                this._rec = null;
                this._res = null;
            }

            if (this._md) {
                if (this._md.stop)
                    this._md.stop();
                else
                    this._md.getTracks().map(t => t.stop());
            }
            this._md = null;
        }
    }

    // #region FileInputSources
    // Q> Move IFileInputSource and related Code to different File (create reusable file)

    export function getFileName(type: string, defaultName?: string, appendDate?: boolean): string {
        var ext: string = null;

        // TODO get extension from MIME-Type
        if (typeof (type) == "string")
            var ix = type.indexOf("/");
        if (ix != -1) {
            var main = type.substr(0, ix);
            var part = type.substr(ix + 1);
            ix = part.indexOf(";");
            if (ix != -1)
                part = part.substr(0, ix);

            part = part.trim();

            if (main == "text")
                ext = ".txt";
            else if (main == "application") {

            }
            else if (part.length > 0 && part.length <= 5)
                ext = "." + part;
        }

        if (ext) {
            var tmp = (defaultName || "file");
            if (appendDate !== false) {
                var m = moment();

                tmp += "-" + m.format("yyyy-MM-DD_hh-mm");
            }
            tmp += ext;

            return tmp;
        }
        return "";

    }

    export async function promptFileName(curName: string): Promise<string> {
        // TODO Add Prompt Options e.g. Additional Texts
        var ext: string = null, n = curName;

        // Q> Files with multiple extensions?
        var ix = curName.lastIndexOf(".");
        if (ix != -1) {
            ext = curName.substr(ix);
            n = curName.substr(0, ix);
        }

        n = prompt(cdh.t('data/common/name'), n);
        if (!n)
            throw new Error("Name is Required");

        if (ext) {
            n = n + ext;
        }


        return n;

    }

    export function checkFileConstraints(file: Blob, constraints?: FileInputConstraints) {
        if (!(file instanceof Blob)) return false;
        if (constraints) {
            // TODO Check constraints
        }

        return true;
    }

    export function getFilteredInfoTexts(src: ObservableOrValueReadonly<FileInputInfoText[]>, filterFunc?: (txt: FileInputInfoText) => boolean): KnockoutReadonlyComputed<FileInputInfoText[]> {
        return ko.pureComputed(() => {
            var srcArr = ko.unwrap(src);
            var res: FileInputInfoText[] = [];

            if (srcArr)
                for (var i = 0; i < srcArr.length; i++) {
                    if (!filterFunc || filterFunc(srcArr[i]))
                        res.push(srcArr[i]);
                }

            return res.length ? res : null;
        });
    }

    export class FileListInputSource implements IFileInputSource {
        readonly icon: string = null;
        readonly name: string = "files";
        readonly displayName: ObservableOrValueReadonly<string> = "files";

        readonly isAutomaticFileName: boolean = true;
        constructor(readonly files: FileList | File[], readonly options?: FileInputSourceOptions) {
        }

        private createSelectionViewModelBase(multiple: boolean): FileSelectionViewModel {
            var vm = new FileSelectionViewModel();
            vm.files(this.files);
            vm.canSelectFile(false);
            vm.multiple(multiple);

            var o = this.options;
            var c: FileInputConstraints = null;
            if (o) {
                vm.constraints(c = o.constraints);

                if (o.title)
                    vm.title(ko.unwrap(o.title));

                if (o.infoTexts) {
                    var filterFunc = (txt: FileInputInfoText) => false;

                    vm.infoTexts = getFilteredInfoTexts(o.infoTexts, filterFunc);
                }
            }

            return vm;
        }

        async getFileAsync(): Promise<FileInputResult> {
            var vm = this.createSelectionViewModelBase(false);

            var f = await vm.showDialog();


            return f[0];
        }

        async getFilesAsync(): Promise<FileInputResult[]> {
            var vm = this.createSelectionViewModelBase(true);

            var f = await vm.showDialog();

            return f;
        }

        prepare(options: FileInputSourceOptions): IFileInputSource {
            return new FileListInputSource(this.files, options);
        }

    }

    export class FileResultInputSource implements IFileInputSource {
        readonly icon: string = null;
        readonly name: string = "files";
        readonly displayName: ObservableOrValueReadonly<string> = "files";

        readonly isAutomaticFileName: boolean = true;
        constructor(readonly files: FileInputResult[], readonly options?: FileInputSourceOptions) {
        }

        private getFilesBase(): FileInputResult[] {
            // TODO Check Constraints
            var c: FileInputConstraints;
            if (this.options)
                c = this.options.constraints;

            var fArr = this.files.filter(f => checkFileConstraints(f.file, c));

            return fArr;
        }

        async getFileAsync(): Promise<FileInputResult> {
            var f = this.getFilesBase();

            return f[0];
        }

        async getFilesAsync(): Promise<FileInputResult[]> {
            var f = this.getFilesBase();

            return f;
        }

        prepare(options: FileInputSourceOptions): IFileInputSource {
            return new FileResultInputSource(this.files, options);
        }

    }

    class FileSelectionEntryViewModel {

        readonly fileName: string;
        readonly ext: string;

        readonly name: KnockoutObservable<string>;

        constructor(readonly parent: FileSelectionViewModel, readonly file: File) {

            let fn: string = null, ext = null, n = null;

            if (file instanceof File)
                fn = file.name;

            if (fn) {
                let ix = fn.lastIndexOf(".");
                if (ix != -1) {
                    n = fn.substr(0, ix);
                    ext = fn.substr(ix);
                }
            }

            this.fileName = fn;
            this.ext = ext;
            this.name = ko.observable<string>(n);


            this.matchesConstraint = checkFileConstraints(file, parent.constraints());
            this.isSelected = ko.observable(this.matchesConstraint);

        }

        readonly matchesConstraint: boolean
        readonly isSelected: KnockoutObservable<boolean>;

        readonly uploadName = ko.pureComputed(() => {
            let n = ko.unwrap(this.name);
            if (n)
                return n + ko.unwrap(this.ext);
            else
                return ko.unwrap(this.fileName);
        });

        toResult(): FileInputResult {
            return {
                file: this.file,
                name: this.uploadName()
            };
        }

    }

    var titleFileSel = t2("view/fileSelection/title");

    export class FileSelectionViewModel {
        readonly dialogResult = ko.observable<boolean>(null);

        readonly title: KnockoutObservable<string>;
        infoTexts?: ObservableOrValueReadonly<FileInputInfoText[]>;

        readonly files: KnockoutObservable<FileList | File[]>;
        readonly fileEntries: KnockoutReadonlyComputed<FileSelectionEntryViewModel[]>;
        readonly hasMultiple: KnockoutReadonlyObservable<boolean>;
        readonly fileNames = ko.pureComputed(() => {
            var res = "";

            var fl = this.files();
            if (fl) {
                if (fl.length != 1)
                    res += "[" + fl.length + "] ";

                for (var i = 0; i < fl.length; i++) {
                    if (i != 0) res += ", ";
                    res += fl[i].name;
                }
            }

            return res;
        });

        readonly multiple = ko.observable(false);
        readonly constraints = ko.observable<FileInputConstraints>();
        readonly filter: KnockoutObservable<string> = ko.pureComputed(() => {
            var c = ko.unwrap(this.constraints);
            if (c) {
                // TODO GetFilter For Constraint
                // Or it might be better to create a BindingHandler that enforces the constraints on a File-Type Input
                if (c.allowedTypes)
                    return c.allowedTypes.join(",");
            }

            return null;
        });
        readonly canSelectFile = ko.observable(true);
        readonly canRenameFile = ko.observable(false);


        private _res: FileInputResult[] = null;

        constructor() {
            var tBase = titleFileSel;
            var rOverride = ko.observable<ObservableOrValueReadonly<string>>();
            this.title = ko.pureComputed({
                write: rOverride, read: () => {
                    var res = ko.unwrap(ko.unwrap(rOverride));
                    if (!res)
                        res = ko.unwrap(tBase);
                    return res;
                }
            });


            this.files = ko.observable<FileList>();
            var hasMultiple = ko.observable(false);
            this.fileEntries = ko.computed(() => {
                var fl = this.files();
                var res: FileSelectionEntryViewModel[] = [];

                if (fl && fl.length) {
                    for (var i = 0; i < fl.length; i++) {
                        var entry = new FileSelectionEntryViewModel(this, fl[i]);

                        res.push(entry);
                    }

                }

                hasMultiple(res.length > 1);

                return res;
            }).extend({ deferred: true });
            this.hasMultiple = hasMultiple;

            //this.file(file);
        }

        async submit() {
            var entries = ko.unwrap(this.fileEntries);

            var results = entries.filter(e => e.matchesConstraint && e.isSelected())
                .map(e => e.toResult());



            if (results.length) {
                this._res = results;


                this.dialogResult(true);
            }

        }

        showDialog(popup?: IDialogContainerViewModel): Promise<FileInputResult[]> {


            return cdh.ui.showDialogValue({
                title: this.title,
                template: { type: "id", value: "templates/core/fileSource-fileSelection-dialog" },
                size: "default"
            }, this, m => m._res, popup);
        }
    }

    export class SelectionFileInputSource implements IFileInputSource {
        icon = "fa-upload";
        name = "select";
        displayName = titleFileSel;
        isAutomaticFileName = false;

        constructor(readonly options?: FileInputSourceOptions) {

        }

        private createSelectionViewModelBase(multiple: boolean): FileSelectionViewModel {
            var vm = new FileSelectionViewModel();
            vm.multiple(multiple);

            var o = this.options;
            var c: FileInputConstraints = null;
            if (o) {
                vm.constraints(c = o.constraints);

                if (o.title)
                    vm.title(ko.unwrap(o.title));

                if (o.infoTexts) {
                    var filterFunc = (txt: FileInputInfoText) => true;

                    vm.infoTexts = getFilteredInfoTexts(o.infoTexts, filterFunc);

                }
            }

            return vm;
        }



        async getFileAsync(): Promise<FileInputResult> {

            var vm = this.createSelectionViewModelBase(false);

            var f = await vm.showDialog();


            return f[0];
        }

        async getFilesAsync(): Promise<FileInputResult[]> {
            var vm = this.createSelectionViewModelBase(true);

            var f = await vm.showDialog();

            return f;
        }


        prepare(options: FileInputSourceOptions): IFileInputSource {
            return new SelectionFileInputSource(options);
        }



    }

    fileSources.push(new SelectionFileInputSource());

    class CameraFileInputSource implements IFileInputSource {
        icon = "fa-camera";
        name = "camera";
        displayName = CameraViewModel.title;
        isAutomaticFileName = true;

        constructor(readonly options?: FileInputSourceOptions) {

        }

        async getFileAsync(): Promise<FileInputResult> {

            var vm = new CameraViewModel();
            var o = this.options;
            var c: FileInputConstraints = null;
            if (o) {
                c = o.constraints;

                if (o.title)
                    vm.title(ko.unwrap(o.title));

            }

            var b = await vm.showDialog();

            if (checkFileConstraints(b, c)) {
                var n = getFileName(b.type, this.name)

                return {
                    file: b,
                    name: await promptFileName(n)
                };
            }

            throw new Error("Invalid File");

        }

        async getFilesAsync(): Promise<FileInputResult[]> {
            return [await this.getFileAsync()];
        }

        prepare(options: FileInputSourceOptions): IFileInputSource {
            // TODO Check Options (especially constraints)
            return new CameraFileInputSource(options);
        }



    }

    export class CameraViewModel {
        readonly dialogResult = ko.observable<boolean>();
        readonly isBusy = utils.createBusyCounter();
        private _result?: Blob;

        static readonly title = t2("view/fileSelection/imageCapture");
        readonly title: KnockoutObservable<string>;

        readonly file = ko.observable<File>();

        constructor() {
            var tBase = CameraViewModel.title;
            var rOverride = ko.observable<ObservableOrValueReadonly<string>>();
            this.title = ko.pureComputed({
                write: rOverride, read: () => {
                    var res = ko.unwrap(ko.unwrap(rOverride));
                    if (!res)
                        res = ko.unwrap(tBase);
                    return res;
                }
            });
        }

        handleSubmit() {
            var f = this.file();

            if (f) {
                this._result = f;
                this.dialogResult(true);
            }
        }

        async showDialog(popup?: IDialogContainerViewModel) {
            var self = this;
            self._result = undefined;
            self.dialogResult(null);

            var diaOptions: IDialogOptions = {
                template: { type: "id", value: "templates/core/fileSource-camera-dialog" },
                title: self.title,
                size: "default"
            };

            if (!capture.hasCamera)
                throw new Error("Camera is Required");

            if (await cdh.ui.showDialog(this, diaOptions, popup)) {
                var res = self._result;
                self._result = undefined;

                return res;
            }

            throw new Error("Dialog cancelled");
        }

    }

    class AudioRecordFileInputSource implements IFileInputSource {
        icon = "fa-microphone";
        name = "audioRecord";
        displayName = AudioRecordViewModel.title;
        isAutomaticFileName = true;

        constructor(readonly options?: FileInputSourceOptions) {

        }

        async getFileAsync(): Promise<FileInputResult> {

            var vm = new AudioRecordViewModel();
            var o = this.options;
            var c: FileInputConstraints = null;
            if (o) {
                c = o.constraints;
                if (o.title)
                    vm.title(ko.unwrap(o.title));
                //if (o.allowedTypes)
                //    vm.filter(o.allowedTypes.join("|"));
            }

            var b = await vm.showDialog();

            if (checkFileConstraints(b, c)) {
                var n = getFileName(b.type, this.name)

                return {
                    file: b,
                    name: await promptFileName(n)
                };
            }

            throw new Error("Invalid File");
        }

        async getFilesAsync(): Promise<FileInputResult[]> {
            return [await this.getFileAsync()];
        }

        prepare(options: FileInputSourceOptions): IFileInputSource {
            // TODO Check Options
            return new AudioRecordFileInputSource(options);
        }



    }

    export class AudioRecordViewModel {
        readonly dialogResult = ko.observable<boolean>();
        readonly isBusy = utils.createBusyCounter();
        private _result?: Blob;

        static readonly title = t2("view/fileSelection/audioCapture");
        readonly title: KnockoutObservable<string>;

        readonly file = ko.observable<File>();

        constructor() {
            var tBase = AudioRecordViewModel.title;
            var rOverride = ko.observable<ObservableOrValueReadonly<string>>();
            this.title = ko.pureComputed({
                write: rOverride, read: () => {
                    var res = ko.unwrap(ko.unwrap(rOverride));
                    if (!res)
                        res = ko.unwrap(tBase);
                    return res;
                }
            });
        }

        handleSubmit() {
            var f = this.file();

            if (f) {
                this._result = f;
                this.dialogResult(true);
            }
        }

        async showDialog(popup?: IDialogContainerViewModel) {
            var self = this;
            self._result = undefined;
            self.dialogResult(null);

            var diaOptions: IDialogOptions = {
                template: { type: "id", value: "templates/core/fileSource-audioRecord-dialog" },
                title: self.title,
                size: "default"
            };

            if (!capture.canRecordAudio)
                throw new Error("audioRecord is Required");

            if (await cdh.ui.showDialog(this, diaOptions, popup)) {
                var res = self._result;
                self._result = undefined;

                return res;
            }

            throw new Error("Dialog cancelled");
        }

    }

    if (checkComplete)
        checkComplete.then(() => {
            if (hasCamera) {
                fileSources.push(new CameraFileInputSource());
            }

            if (canRecordAudio) {
                fileSources.push(new AudioRecordFileInputSource());
            }
        });

    class ClipboardFileInputSource implements IFileInputSource {
        icon = "fa-clipboard";
        name = "clipboard";
        displayName = t2("view/fileSelection/clipboard");
        isAutomaticFileName = true;

        constructor(readonly options?: FileInputSourceOptions) {

        }



        async getFileAsync(): Promise<FileInputResult<Blob | File>> {
            var res = await this.getFilesBaseAsync();
            var fRes = res ? res[0] : null;

            if (fRes) {
                return {
                    file: fRes.file,
                    name: await promptFileName(fRes.name)
                };
            }
            throw new Error("No File");
        }
        async getFilesBaseAsync(): Promise<FileInputResult<Blob | File>[]> {

            var o = this.options;
            var c: FileInputConstraints = null;
            if (o) {
                c = o.constraints;
                //if (o.title)
                //    vm.title(ko.unwrap(o.title));
                //if (o.allowedTypes)
                //    vm.filter(o.allowedTypes.join("|"));
            }

            try {
                var cb = await navigator.clipboard.read();

                var res: FileInputResult<Blob | File>[] = [];

                for (var i = 0; i < cb.length; i++) {
                    var cbi = cb[i];
                    console.log(cbi.types);

                    var b = await cbi.getType(cbi.types[0]);
                    if (checkFileConstraints(b, c)) {
                        var n: string;
                        if (b instanceof File) n = b.name;
                        else
                            n = getFileName(b.type, "clipboard-item_" + (i + 1))

                        res.push({
                            file: b,
                            name: n
                        });
                    }

                }


                return res;
            }
            catch (ex) {
                return [];
            }
        }
        async getFilesAsync(): Promise<FileInputResult<Blob | File>[]> {
            var fRes = await this.getFilesBaseAsync();
            debugger;

            if (fRes) {
                var fRes2: FileInputResult<Blob | File>[] = [];
                for (var i = 0; i < fRes.length; i++) {
                    fRes2.push({
                        file: fRes[i].file,
                        name: await promptFileName(fRes[i].name)
                    });
                }

                return fRes2;
            }

            return null;
        }
        prepare(options: FileInputSourceOptions): IFileInputSource {
            // TODO Check Constraints
            return new ClipboardFileInputSource(options);
        }

    }
    if (navigator.clipboard.read)
        fileSources.push(new ClipboardFileInputSource());

    // #endregion

    type CaptureOptionsBase = {
        file: KnockoutObservable<Blob>;
        enabled?: KnockoutObservable<boolean>;

        onCaptured?: (result: Blob) => Promise<void> | void;
        onCancelled?: () => Promise<void> | void;

    }

    type ImageCaptureOptions = CaptureOptionsBase & {
        imageType?: string
    }

    type AudioCaptureOptions = CaptureOptionsBase & {
    }

    function getImageCaptureOptions(valueAccessor: { (): ImageCaptureOptions | KnockoutObservable<Blob> }) {
        var value = valueAccessor();

        if (!value) throw new Error("value required");
        if (ko.isObservable(value))
            value = { file: value };
        else if (!ko.isObservable(value.file))
            throw new Error("value.file isRequired");

        if (typeof value.imageType !== "string" || !value.imageType)
            value.imageType = "image/png";

        return value;
    }



    ko.bindingHandlers.imageCapture = {
        init(elm: Element, valueAccessor: { (): ImageCaptureOptions | KnockoutObservable<Blob> }) {
            if (!hasCamera) {
                elm.classList.add("d-none");
                return;
            }

            var options = getImageCaptureOptions(valueAccessor);

            var $elm = $(elm);
            var vidElm: HTMLVideoElement = <HTMLVideoElement>$elm.find("video")[0];

            var vc = new VideoCapture(vidElm);
            ko.utils.domData.set(elm, "_videoCapture", vc)

            vc.onUpdatePhoto = c => {
                let p = $.Deferred();

                c.toBlob(async b => {
                    try {
                        if (options.file) options.file(b);
                        if (options.onCaptured) await options.onCaptured(b);
                    }
                    finally {
                        p.resolve();
                    }

                }, options.imageType);

                return p.promise();
            };

            ko.utils.domNodeDisposal.addDisposeCallback(elm, () => vc.endCapture());

            elm.classList.add("d-none");

            $elm.on("click", "button.photo", e => {
                vc.takePicture();
            });

            if (options.onCancelled)
                $elm.on("click", "button.cancel", e => {
                    options.onCancelled();
                });


            if (ResizeObserver) {
                if (vidElm.parentElement && vidElm.parentElement.classList.contains("ocr-capture"))
                    vidElm.parentElement.style.height = "auto";
                var action = () => {
                    vidElm.style.maxHeight = elm.clientHeight + "px";
                }

                var ro = new ResizeObserver(action);

                ro.observe(elm);
                ko.utils.domNodeDisposal.addDisposeCallback(elm, () => ro.disconnect());
            }

            return { controlsDescendantBindings: true };
        },

        update(elm: Element, valueAccessor: { (): ImageCaptureOptions | KnockoutObservable<Blob> }) {
            if (!hasCamera) return;
            var options = getImageCaptureOptions(valueAccessor);
            var vc: VideoCapture = ko.utils.domData.get(elm, "_videoCapture");

            if (!ko.isObservable(options.enabled) || options.enabled()) {
                vc.beginCapture().then(() => elm.classList.remove("d-none"), e => {
                    alert(e);
                });
            }
            else {
                vc.endCapture();
                elm.classList.add("d-none");
            }
        }
    }

    function getAudioCaptureOptions(valueAccessor: { (): AudioCaptureOptions | KnockoutObservable<Blob> }) {
        var value = valueAccessor();

        if (!value) throw new Error("value required");
        if (ko.isObservable(value))
            value = { file: value };
        else if (!ko.isObservable(value.file))
            throw new Error("value.file isRequired");

        //if (typeof value.imageType !== "string" || !value.imageType)
        //    value.imageType = "image/png";

        return value;
    }

    ko.bindingHandlers.audioCapture = {
        init(elm: Element, valueAccessor: { (): AudioCaptureOptions | KnockoutObservable<Blob> }) {
            if (!canRecordAudio) {
                elm.classList.add("d-none");
                return;
            }

            var options = getAudioCaptureOptions(valueAccessor);

            var $elm = $(elm);

            var vc = new AudioCapture();
            ko.utils.domData.set(elm, "_audioCapture", vc)

            vc.addCompletedCallback(async b => {

                try {
                    if (options.file) options.file(b);
                    if (options.onCaptured) await options.onCaptured(b);
                }
                finally {

                }

            });

            ko.utils.domNodeDisposal.addDisposeCallback(elm, () => vc.endCapture());

            elm.classList.add("d-none");

            $elm.on("click", "button.start", e => {
                vc.start();
            });
            $elm.on("click", "button.stop", e => {
                vc.stop();
            });
            $elm.on("click", "button.startstop", e => {
                if (vc.recording())
                    vc.stop();
                else
                    vc.start();
            });
            if (options.onCancelled)
                $elm.on("click", "button.cancel", e => {
                    options.onCancelled();
                });

            var $btnStart = $elm.find("button.start");
            var $btnStop = $elm.find("button.stop");
            var $btnStartStop = $elm.find("button.startstop");

            updateButtons();
            vc.recording.subscribe(() => updateButtons());


            return { controlsDescendantBindings: true };

            function updateButtons() {
                var rec = vc.recording();

                if (rec) {
                    $btnStart.attr("disabled", "disabled");
                    $btnStop.removeAttr("disabled");
                }
                else {
                    $btnStop.attr("disabled", "disabled");
                    $btnStart.removeAttr("disabled");
                }

            }
        },

        update(elm: Element, valueAccessor: { (): AudioCaptureOptions | KnockoutObservable<Blob> }) {
            if (!canRecordAudio) return;
            var options = getAudioCaptureOptions(valueAccessor);
            var vc: AudioCapture = ko.utils.domData.get(elm, "_audioCapture");

            if (!ko.isObservable(options.enabled) || options.enabled()) {
                vc.beginCapture().then(() => elm.classList.remove("d-none"), e => {
                    alert(e);
                });
            }
            else {
                vc.endCapture();
                elm.classList.add("d-none");
            }
        }
    }

}

interface MediaStream {
    stop(): void;
}